@if (params) {
  <cil-energy-activate-consent [params]="params" (onEnd)="end()"></cil-energy-activate-consent>
}
